import React from 'react';
import {observer} from 'mobx-react';
import {Panel, Button, CheckboxWithLabel} from 'shared/components';
import {t} from 'shared/core';
import {FormattedMessage} from 'react-intl';
import CollagePayrollIllustration from 'img/payroll/collage_payroll_illustration@2x.png';
import InterestedInPayrollModal from './InterestedInPayrollModal';

const Payroll = observer(({uiState}) => {
  const {notInterestedInPayroll, payrollNotificationSent} = uiState;

  return (
    <div>
      <Panel.Header title={t('employees.hire.payroll.Pay your people directly in Collage')}/>
      <div className='flex align-items-middle'>
        <div className='flex col-8 align-items-start ml1 mt1'>
          <ul className='IconList IconList--checkmark'>
            <li><FormattedMessage id='employees.hire.payroll.Pay your employees in Collage and stop juggling multiple systems'/></li>
            <li><FormattedMessage id='employees.hire.payroll.Avoid double entry by having onboarding, timesheets, and vacation pay integrated with payroll'/></li>
            <li><FormattedMessage id='employees.hire.payroll.Access pay stubs and T4s directly in Collage'/></li>
          </ul>
        </div>
        <div className='col-4 ml1 mr1 jumbo'>
          <img className='full-width mt1' src={CollagePayrollIllustration} alt='providers'/>
        </div>
      </div>
      {!payrollNotificationSent && <div className='mt2 flex align-items-middle'>
        <Button className='Btn--lagoon mr2' onClick={() => uiState.sendPayrollNotification()} disabled={notInterestedInPayroll}>
          <FormattedMessage id='employees.hire.payroll.Get Quote'/>
        </Button>
        <CheckboxWithLabel
          label="employees.hire.payroll.No, thanks. I'll manage payroll manually."
          checked={notInterestedInPayroll}
          onChange={(e) => uiState.updatePayrollInterest(e.checked)}
        />
      </div>}
      <InterestedInPayrollModal uiState={uiState}/>
    </div>
  );
});

export default Payroll;
